import { LabelContentFieldsFragment } from "generated-graphql/graphql";
import { QR_CODE_SERVICE_URL } from "util/qrCodeService";

type DotProfileContent = Pick<
  LabelContentFieldsFragment,
  "dotProperShippingName" | "dotIdNumber" | "dotHazardClass"
>;

/**
 * Whether a container's DOT shipping profile is entirely unset. Mirrors the
 * pdf-generator lambda's `hasDotBlock` check (hazardousWasteLabelComponents.tsx),
 * inverted: that check decides whether the DOT block renders at all on the
 * printed label, this one decides whether to warn that it's missing.
 */
export function isDotProfileIncomplete(content: DotProfileContent): boolean {
  return !(content.dotProperShippingName || content.dotIdNumber || content.dotHazardClass);
}

/**
 * Builds the qr-code-generator service URL for a container's label QR,
 * copying the param set QRCodeDisplay builds (components/QRCodeDisplay/index.tsx)
 * minus its screen/print theme colors, which don't apply to a printed label.
 */
export function qrImageUrl(qrUrl: string): string {
  const params = new URLSearchParams({
    text: qrUrl,
    width: "400",
    margin: "2",
    errorCorrectionLevel: "H",
  });
  return `${QR_CODE_SERVICE_URL}?${params.toString()}`;
}
